import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const StyledButton = styled.button`
    height: 5vh;
    transition: box-shadow 0.25s ease-out;
    border-color: var(--orange-color) !important;
    min-width: 5rem;
    width: 25vw;
    max-width: 10rem;
`;

const StyledTd = styled.td`
    background-color: transparent !important;
`;

const CalculationResultPart = ({ calculated, hideAll, results, calculate, trailText="TL" }) => {
    const navigate = useNavigate();

    const clearFields = () => {
        navigate(window.location.pathname);
        navigate(0);
    };

    return (
        <>
            {calculated && !hideAll && (
                <div className="calculate container-fluid bg-custom-green p-4">
                    <h3 className="text-success">Hesaplama Sonucu</h3>
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col" style={{ backgroundColor: "transparent" }}>Kalem</th>
                                <th scope="col" style={{ width: '60%', maxWidth: '60%', backgroundColor: "transparent" }}>Değer</th>
                            </tr>
                        </thead>
                        <tbody>
                            {results.map((result, index) => (
                                <tr key={index}>
                                    <StyledTd className="fw-bold">{result.text}</StyledTd>
                                    <StyledTd>
                                        <span 
                                            className={index === results.length - 1 ? 'text-orange fw-bold' : ''} 
                                            style={{ display: typeof result.value === 'number' && result.value >= 0.01 ? 'inline' : 'none' }}
                                        >
                                            {Number(result.value.toFixed(2)).toLocaleString('tr-TR')}
                                        </span>
                                        <span style={{ display: !(typeof result.value === 'number' && result.value >= 0.01) ? 'inline' : 'none' }}>
                                            {result.value}
                                        </span>
                                        {index === results.length - 1 && <span className="text-orange fw-bold"> {trailText}</span>}
                                    </StyledTd>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-end mt-3">
                        <StyledButton className="border bg-orange text-white mx-2" onClick={calculate}>
                            Tekrar Hesapla
                        </StyledButton>
                        <StyledButton className="border text-orange mx-2" onClick={clearFields}>
                            Temizle
                        </StyledButton>
                    </div>
                </div>
            )}

            {!calculated && !hideAll && (
                <div className="calculate container-fluid bg-gray p-4 bg-custom-gray" style={{ textAlign: '-webkit-right' }}>
                    <div className="d-flex flex-row flex-sm-row align-items-center" style={{ width: '70vw', maxWidth: '20rem' }}>
                        <StyledButton className="border bg-orange text-white w-100 m-2" onClick={calculate}>
                            Hesapla
                        </StyledButton>
                        <StyledButton className="border text-orange w-100 mx-2" onClick={clearFields}>
                            Temizle
                        </StyledButton>
                    </div>
                </div>
            )}
        </>
    );
};

export default CalculationResultPart;
